// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__18dGH","requiredAsterisk":"Info_requiredAsterisk__3AwTG"};